import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import { edmCampaign } from '@bingads-webui/edm-campaign';
import { errorHandler } from './utils';

export const WithAudienceAssociationsRepository = ({
  WrappedComponent, i18n, campaignId, adGroupId, cid, aid, ...others
}) => {
  const [dataIsReady, setDataIsReady] = useState(false);
  const [audienceAssociations, setAudienceAssociations] = useState(null);

  useEffect(() => {
    if (!cid || !aid || !campaignId) {
      return;
    }

    let entity = edmCampaign.Customers.$withKey(cid).Accounts.$withKey(aid).Campaigns.$withKey(campaignId);
    if (adGroupId) {
      entity = entity.AdGroups.$withKey(adGroupId);
    }
    entity.AudienceAssociations.get({
      filter: { where: "(Status eq Enum.AdGroupCriterionStatus'Active' or Status eq Enum.AdGroupCriterionStatus'Paused' or Status eq Enum.AdGroupCriterionStatus'Excluded') and AudienceCriterion/AudienceType eq 'InMarket'" },
      top: 2000,
    }).toPromise().then((response) => {
      setAudienceAssociations(response);
      setDataIsReady(true);
    }).catch(((error) => {
      errorHandler(WrappedComponent, i18n)(error);
    }));
  }, [WrappedComponent, adGroupId, aid, campaignId, cid, i18n]);

  return dataIsReady ? <WrappedComponent
    audienceAssociations={audienceAssociations}
    i18n={i18n}
    adGroupId={adGroupId}
    {...others}
  /> : <WrappedComponent
    audienceAssociations={{ dataNotReady: true }}
    i18n={i18n}
    adGroupId={adGroupId}
    {...others}
  />;
};

WithAudienceAssociationsRepository.propTypes = {
  WrappedComponent: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  campaignId: PropTypes.number.isRequired,
  adGroupId: PropTypes.number,
  cid: PropTypes.number.isRequired,
  aid: PropTypes.number.isRequired,
};

WithAudienceAssociationsRepository.defaultProps = {
  adGroupId: null,
};
